<template>
  <div class="chart-case">
    <div
      class="chart-wrap"
      v-loading="loading"
      element-loading-text="数据量巨大，正在计算中..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 1)">
      <div style="flex: 1; position: relative; width: 70%">
        <div class="download-wrap" style="right: calc(var(--ROOTFONTFIZE) * (55 / 144))">
          <Download
            :dButtonsDownloads="dButtonsDownloads"
            :excel_info="excel_info"
            echartRefName="chart" />
        </div>
        <div
          class="iconfont icon-fangda"
          style="top: 3px; right: 11.5%"
          @click="show_chart_dialog = true"></div>
        <div ref="chart" style="width: 100%; height: 100%"></div>
      </div>
      <div style="width: 30%; max-width: 400px">
        <div class="download-wrap">
          <Download
            :dButtonsDownloads="dButtonsDownloads_2"
            :excel_info="excel_info_2"
            echartRefName="chart" />
        </div>
        <el-table
          class="table1"
          :header-cell-style="tableStyle"
          :data="table_data"
          height="360"
          style="width: 100%"
          size="mini">
          <el-table-column
            min-width="130"
            v-for="col in table_column"
            :label="col.label"
            :prop="col.prop"
            :align="col.align"
            :key="col.prop">
            <template slot-scope="scope">
              <div v-if="col.label === '主要参数提示'">
                {{ scope.row[col.prop] }}
              </div>
              <div v-else>
                <div v-if="scope.row.index === 'beta' || scope.row.index === 'sharp_ratio'">
                  {{ scope.row[col.prop] | fix2_ }}
                </div>
                <div v-else>
                  {{ scope.row[col.prop] | pct }}
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="download-wrap">
        <Download
          :dButtonsDownloads="dButtonsDownloads"
          :excel_info="excel_info"
          echartRefName="chart" />
      </div>
    </div>
    <ChartDialog :show.sync="show_chart_dialog" :echart_options="chart_dialog_options" />
  </div>
</template>

<script>
import { fnReturnTableStyle, fnGetMuchDecimals } from '@/utils/util';
import ChartDialog from '@/components/Basic/ChartDialog.vue';
import Download from '@/components/Basic/Download.vue';

import { numberFix2, number2Pct } from '@/utils';

export default {
  props: {
    queryString: String,
  },
  components: { Download, ChartDialog },
  data() {
    return {
      ROOTFONTFIZE: '',
      excel_info: Object.freeze({
        overviewName: '期间分派率-图表',
        excel_data: [],
        json_fields: {},
      }),
      excel_info_2: Object.freeze({
        overviewName: '期间分派率-表格',
        excel_data: [],
        json_fields: {},
      }),
      dButtonsDownloads: Object.freeze([
        {
          id: '241020',
          name: '下载图片',
        },
        {
          id: '241020',
          name: '下载表格',
        },
      ]),
      dButtonsDownloads_2: Object.freeze([
        /*  {
          id: '241020',
          name: '下载图片',
        }, */
        {
          id: '241020',
          name: '下载表格',
        },
      ]),
      table_data: [],
      table_column: Object.freeze([
        {
          label: '主要参数提示',
          prop: 'index',
          align: 'left',
        },
        {
          label: '自选指数',
          prop: 'portfolio',
          align: 'right',
        },
        {
          label: '基准',
          prop: 'benchmark',
          align: 'right',
        },
      ]),
      show_chart_dialog: false,
      chart_data: [],
      chart_dialog_options: {},
      loading: true,
    };
  },
  computed: {
    tableStyle() {
      const val = this.$store.state.theme === 'dark';
      return () => fnReturnTableStyle(val);
    },
    currentTheme() {
      return this.$store.state.theme; // 从Vuex中获取当前的主题值
    },
  },
  watch: {
    currentTheme(newVal, oldVal) {
      setTimeout(() => {
        this.renderChart();
      }, 0);
    },
    queryString: {
      handler: function () {
        this.loadData();
      },
      immediate: true,
    },
  },
  filters: {
    pct(n) {
      if (n === '') return '';
      return number2Pct(n);
    },
    fix2(n) {
      if (n === '') return '';
      return numberFix2(n, 2);
    },
    fix2_(n) {
      if (n === '') return '';
      return numberFix2(n, 2, 'ceil');
    },
  },
  methods: {
    setDownloadData(data = {}) {
      const { data1 = [], ipo_date = [], pic1_lines = {} } = data.data || {};
      const line = pic1_lines.line || {};

      const new_ipo_data = ipo_date.reduce((p, c) => {
        if (!p[c.IPO_date]) {
          p[c.IPO_date] = {
            name: c.REITs_name,
            code: c.reit_code,
          };
        } else {
          p[c.IPO_date].name += `\n${c.REITs_name}`;
          p[c.IPO_date].code += `\n${c.reit_code}`;
        }
        return p;
      }, {});
      const new_data = data1.map((item) => {
        return {
          ...item,
          ipo: new_ipo_data[item.tr_date] || {},
        };
      });

      this.excel_info = Object.freeze({
        ...this.excel_info,
        excel_data: new_data || [],
        json_fields: {
          日期: 'tr_date',
          分红回报率: 'div_yield_ttm',
          指数点位: 'portfolio',
          ipo股票代码: {
            field: 'ipo',
            callback: (v) => {
              return v.code;
            },
          },
          ipo股票名称: {
            field: 'ipo',
            callback: (v) => {
              return v.name;
            },
          },
        },
        table_head: [`标准差(+1):${line.upper}`, `平均值:${line.avg}`, `标准差(-1):${line.lower}`],
      });
      this.excel_info_2 = Object.freeze({
        ...this.excel_info_2,
        excel_data: data.table || [],
        json_fields: {
          主要参数提示: 'index',
          自选指数: 'portfolio',
          基准: 'benchmark',
        },
      });
    },
    renderChart() {
      // console.clear();
      if (!this.echart_instance) {
        this.echart_instance = this.$echarts.init(this.$refs.chart);
      }
      this.echart_instance.clear();
      let OPTIONDATA =
        this.$store.state.theme == 'dark'
          ? this.$store.state.OPTIONDATA
          : this.$store.state.OPTIONDATA_light;

      const source = this.chart_data;
      const dimensions = Object.keys(source.data1[0]);

      const markPointData = source.ipo_date.map((node) => {
        const { type_, IPO_date, REITs_name } = node;
        return {
          coord: [IPO_date, 0, type_, REITs_name],
        };
      });

      let theme = this.$store.state.theme;
      const options = {
        dataset: [{ dimensions, source: source.data1 }],
        series: [
          {
            z: 1,
            name: '分红回报率(左轴)',
            type: 'line',
            areaStyle: {
              opacity: 1,
            },
            itemStyle: {
              color: 'rgba(93, 204, 200, 1)',
            },
            symbol: 'none',
            datasetIndex: 0,
            yAxisIndex: 0,
            encode: {
              x: 'tr_date',
              y: 'div_yield_ttm',
            },
          },
          {
            z: 2,
            // name: '指数点位(左轴)',
            name: '指数点位(右轴)',
            type: 'line',
            symbol: 'none',
            datasetIndex: 0,
            yAxisIndex: 1,
            encode: {
              x: 'tr_date',
              y: 'portfolio',
            },
            itemStyle: {
              color: 'rgba(86, 84, 202, 1)',
            },
          },
          {
            name: 'IPO标志',
            type: 'line',
            symbol: 'none',
            itemStyle: {
              color: 'rgba(212, 48, 48, 1)',
            },
            // fix 这里不需要显示线条
            datasetIndex: 999,
            yAxisIndex: 2,
            markPoint: {
              data: markPointData,
              symbol: 'triangle',
              symbolSize: 18,
              symbolOffset: [0, '50%'],
              label: {
                show: false,
              },
              emphasis: {
                label: {
                  show: true,
                  color: OPTIONDATA.title.textStyle.color,
                  position: 'top',
                  align: 'center',
                  backgroundColor: 'Transparent',
                  padding: [0, 0, 0, 0],
                  borderRadius: 3,
                  fontSize: 14,
                  formatter: (val) => {
                    const [date, _, type, name] = val.data.coord;
                    return `${date}\n${type}: ${name}`;
                  },
                  rich: {
                    b: {
                      color: 'red',
                    },
                  },
                },
              },
              itemStyle: {
                color: 'rgba(212, 48, 48, 1)',
                label: {
                  show: true,
                },
              },
            },
          },
          {
            z: 5,
            name: '标准差(+1)',
            type: 'line',
            // fix 这里不需要显示线条
            datasetIndex: 999,
            yAxisIndex: 0,
            itemStyle: {
              color: 'rgba(255, 174, 88, 1)',
            },
            markLine: {
              precision: 6,
              symbol: ['none', 'none'],

              data: [
                {
                  yAxis: source.pic1_lines.line.upper,
                },
              ],

              lineStyle: {
                type: 'dashed',
                color: 'rgba(255, 174, 88, 1)',
                width: 1,
              },

              label: {
                show: false,
              },
            },
          },
          {
            z: 5,
            zIndex: 5,
            name: '平均值',
            type: 'line',
            // fix 这里不需要显示线条
            datasetIndex: 999,
            yAxisIndex: 0,
            itemStyle: {
              color: theme == 'dark' ? 'rgba(255, 255, 255, 1)' : '#878787',
            },
            markLine: {
              precision: 6,
              symbol: ['none', 'none'],

              data: [
                {
                  yAxis: source.pic1_lines.line.avg,
                },
              ],

              lineStyle: {
                type: 'solid',
                color: theme == 'dark' ? 'rgba(255, 255, 255, 1)' : '#878787',
                width: 1,
              },

              label: {
                show: false,
              },
            },
          },
          {
            z: 5,
            name: '标准差(-1)',
            type: 'line',
            // fix 这里不需要显示线条
            datasetIndex: 999,
            yAxisIndex: 0,
            itemStyle: {
              color: 'rgba(121, 157, 255, 1)',
            },
            markLine: {
              // 精度问题
              precision: 6,
              symbol: ['none', 'none'],

              data: [
                {
                  yAxis: source.pic1_lines.line.lower,
                },
              ],

              lineStyle: {
                type: 'dashed',
                color: 'rgba(121, 157, 255, 1)',
                width: 1,
              },

              label: {
                show: false,
              },
            },
          },
        ],
        legend: {
          type: 'plain',
          left: 'center',
          bottom: 0,
          textStyle: {
            color: OPTIONDATA.legend.textStyle.color,
            fontSize: this.ROOTFONTFIZE * (14 / 144),
          },
          // itemHeight: 5,
          data: [
            {
              name: '分红回报率(左轴)',
              icon: 'circle',
            },
            {
              name: '指数点位(右轴)',
              icon: 'roundRect',
              lineStyle: {
                type: 'solid',
              },
            },
            {
              name: 'IPO标志',
              icon: 'triangle',
            },
            {
              name: '标准差(+1)',
              lineStyle: {
                type: 'dotted',
              },
            },
            {
              name: '平均值',
              icon: 'roundRect',
            },
            {
              name: '标准差(-1)',
              lineStyle: {
                type: 'dotted',
              },
            },
          ],
        },
        tooltip: {
          trigger: 'axis',
          triggerOn: 'mousemove|click',
          formatter: (params) => {
            if (!params.length) return '';
            const item1 = params[0];
            const item2 = params[1];
            const { tr_date, portfolio, div_yield_ttm } = item1.data;
            const t1 = item1
              ? `${item1.marker} ${item1.seriesName}: ${(div_yield_ttm * 100).toFixed(2)}% <br/>`
              : '';
            const t2 = item2
              ? `${item2.marker} ${item2.seriesName}: ${(portfolio * 100).toFixed(2)}%`
              : '';
            const t3 = `<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:rgba(255, 174, 88, 1);"></span> 标准差(+1)：${(
              source.pic1_lines.line.upper * 100
            ).toFixed(2)}%`;
            const t4 = `<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:${
              theme == 'dark' ? 'rgba(255, 255, 255, 1)' : '#878787'
            };box-shadow:${theme == 'dark' ? '0 0 2px #000' : 'none'}"></span> 平均值:${(
              source.pic1_lines.line.avg * 100
            ).toFixed(2)}%`;
            const t5 = `<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:rgba(121, 157, 255, 1);"></span> 标准差(-1):${(
              source.pic1_lines.line.lower * 100
            ).toFixed(2)}%`;
            return `${tr_date}<br/> ${t1} ${t2}<br/>${t3}<br/>${t4}<br/>${t5}`;
          },
        },
        toolbox: {
          // 工具箱按钮
          right: '5%',
          top: -5,
          itemSize: 18,
          iconStyle: {
            borderColor: OPTIONDATA.toolbox.iconStyle.borderColor,
          },
          feature: {
            dataZoom: {}, // 区域缩放
          },
        },
        xAxis: {
          type: 'category',
          interval: '2',
          axisLabel: {
            margin: OPTIONDATA.xAxis.axisLabel.margin,
            fontSize: OPTIONDATA.xAxis.axisLabel.fontSize,
            showMaxLabel: true,
            color: OPTIONDATA.xAxis.axisLabel.color,
          },
        },
        yAxis: [
          {
            scale: true,
            // type: 'value',
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            position: 'left',
            axisLabel: {
              fontSize: 14,
              show: true,

              color: OPTIONDATA.yAxis.axisLabel.color,
              formatter: function (args) {
                args = args * 100;
                let num = fnGetMuchDecimals(args);
                return args.toFixed(num) + '%';
              },
            },
            splitLine: {
              show: false,
            },
          },
          {
            // type: 'value',
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            position: 'right',
            axisLabel: {
              fontSize: 14,
              show: true,

              color: OPTIONDATA.yAxis.axisLabel.color,
              formatter: function (args) {
                // let num = (parseInt(Math.abs(args)) + '').length >= 2 ? 1 : 2;
                // return args.toFixed(num);
                return (args * 100).toFixed(2) + '%';
              },
            },
            splitLine: {
              show: false,
            },
          },
          {
            show: false,
          },
        ],
        grid: {
          top: this.ROOTFONTFIZE * (50 / 144),
          left: this.ROOTFONTFIZE * (30 / 144),
          right: this.ROOTFONTFIZE * (50 / 144),
          bottom: this.ROOTFONTFIZE * (40 / 144),
          containLabel: true,
        },
      };

      this.chart_dialog_options = Object.freeze(options);
      this.echart_instance.setOption(options);
      this.echart_instance.resize();
    },
    async loadData() {
      this.loading = true;
      const { data } = await this.$https.get(
        `/api/v3_1/portfolio_div_yield_ttm?${this.queryString}&show_mode=std`
      );
      if (data.code !== 200) return this.$message.error(data.msg);
      this.chart_data = Object.freeze(data.data);
      this.table_data = Object.freeze(data.table);
      this.loading = false;
      this.renderChart();
      this.setDownloadData(data);
    },
    fnGetWidth() {
      var element = document.getElementById('rootchart');
      let ROOTFONTFIZE = element.offsetWidth;
      ROOTFONTFIZE = ROOTFONTFIZE > 1440 ? 1440 : ROOTFONTFIZE;
      ROOTFONTFIZE = ROOTFONTFIZE < 1400 ? ROOTFONTFIZE - 200 : ROOTFONTFIZE;
      this.ROOTFONTFIZE = ROOTFONTFIZE / 10;
      return;
    },
    resize() {
      this.fnGetWidth();
      this.echart_instance && this.echart_instance.resize();
    },
  },
  mounted() {
    this.resize();
    window.addEventListener('resize', this.resize);
    this.$root.$on('chartResize', () => {
      setTimeout(() => {
        this.resize();
      }, 0);
    });
  },
  beforeDestroy() {
    this.$root.$off('chartResize');
    window.removeEventListener('resize', this.resize);
    this.echart_instance && this.echart_instance.dispose();
    this.echart_instance = null;
  },
};
</script>

<style scoped lang="less">
.chart-wrap {
  position: relative;
  display: flex;
  /deep/.el-table__body .el-table__row .el-table__cell {
    height: calc(var(--ROOTFONTFIZE) * (45 / 144)) !important;
  }
  .download-wrap {
    position: absolute;
    right: 0;
    top: -35px;
  }
}

/* el-table start */

::v-deep .table1 table {
  border: none;
}

::v-deep .el-table__body .el-table__row .el-table__cell {
  background-color: var(--table_bgc);
  color: var(--table_color);
  font-size: calc(var(--ROOTFONTFIZE) * (14 / 144));
  height: calc(var(--ROOTFONTFIZE) * (60 / 144));
  border-bottom: calc(var(--ROOTFONTFIZE) * (1 / 144)) solid var(--table_brc);
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
  background-color: var(--table_bgc_hover);
  /* background-color: var(--table_color_hover); */
  color: var(--table_color_hover);
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell:hover {
  cursor: pointer;
}

::v-deep .el-table::before {
  background-color: var(--table_bgc);
}

::v-deep .el-table {
  border-bottom: none !important;
  background-color: var(--table_bgc);
}

/* el-table end */
</style>
